module.exports = __webpack_public_path__ + "static/media/Share-Image.30de3906.jpg";